<div class="ng-scope">
    <nav class="navbar navbar-expand-lg navbar-light" style="padding-left: 0;">
        <a class="navbar-brand" href="#">PAYMENTS</a>
    </nav>

    <div class="container-fluid" style="margin-bottom: 1em; padding-left: 0; padding-right: 0;">
        <div class="card">
            <div class="card-header">
                <button class="btn ng-binding" style="float: right;" (click)="toggle()">
                    {{buttonName}}
                </button>
            </div>

            <div class="card-body animate-show-hide" id="filterGroup" *ngIf="ShowFilters">
                <form>
                    <div class="row">
                        <div class="col-sm-1">
                            <b>
                                Customer
                            </b>
                        </div>

                        <div class="col-md-11">
                            <mat-form-field appearance="fill">
                                <mat-label>select</mat-label>
                                <mat-select>
                                    <mat-option *ngFor="let cust of custs" [value]="cust.value">
                                        {{cust.viewValue}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row" style="margin-top: 0.5em;">
                        <div class="col-sm-1">
                            <b>
                                From
                            </b>
                        </div>
                        <div class="col-md-3">
                            <mat-form-field appearance="fill">
                                <mat-label>Choose a date</mat-label>
                                <input matInput [matDatepicker]="picker" name="from" id="from">
                                <mat-hint>MM/DD/YYYY</mat-hint>
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>
                            </mat-form-field>
                        </div>

                        <div class="col-sm-1">
                            <b>
                                To
                            </b>
                        </div>
                        <div class="col-md-3">
                            <mat-form-field appearance="fill">
                                <mat-label>Choose a date</mat-label>
                                <input matInput [matDatepicker]="pickers" name="to" id="to">
                                <mat-hint>MM/DD/YYYY</mat-hint>
                                <mat-datepicker-toggle matSuffix [for]="pickers"></mat-datepicker-toggle>
                                <mat-datepicker #pickers></mat-datepicker>
                            </mat-form-field>
                        </div>

                        <div class="col-sm-1">
                            <b>
                                Status:
                            </b>
                        </div>
                        <div class="col-md-3">
                            <mat-form-field appearance="fill">
                                <mat-label>select</mat-label>
                                <mat-select>
                                    <mat-option *ngFor="let st of status" [value]="st.value">
                                        {{st.viewValue}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row" style="margin-top: 2em;">
                        <div class="col-sm-1">
                            <b>
                                Track #
                            </b>
                        </div>
                        <div class="col-sm-3">
                            <mat-form-field appearance="fill">
                                <mat-label>select</mat-label>
                                <mat-select>
                                    <mat-option *ngFor="let tr of track" [value]="tr.value">
                                        {{tr.viewValue}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>


                        <div class="col-sm-1">
                            <b>
                                Loan #
                            </b>
                        </div>
                        <div class="col-sm-3">
                            <mat-form-field appearance="fill">
                                <mat-label>select</mat-label>
                                <mat-select>
                                    <mat-option *ngFor="let loans of loan" [value]="loans.value">
                                        {{loans.viewValue}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <div class="col-sm-1">
                            <b>
                                Borrower
                            </b>
                        </div>
                        <div class="col-sm-3">
                            <mat-form-field appearance="fill">
                                <mat-label>select</mat-label>
                                <mat-select>
                                    <mat-option *ngFor="let br of borrower" [value]="br.value">
                                        {{br.viewValue}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="card" style="margin-top: 0.5em;">
                        <div class="card-header">
                            <h2>Credit Card</h2>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-sm-2">
                                    <b>First Four Digits</b>
                                </div>

                                <div class="col-sm-3">
                                    <mat-form-field appearance="fill">
                                        <mat-label>Enter first four digit</mat-label>
                                        <input matInput type="number" name="firstFourDigit">
                                    </mat-form-field>
                                </div>

                                <div class="col-sm-1">
                                    <button ng-click="$ctrl.clearCcLastFourDigits()" type="button"
                                        class="btn btn-outline-secondary" style="padding: 4px;">CLR
                                    </button>
                                </div>

                                <div class="col-sm-2">
                                    <b>Last Four Digits</b>
                                </div>
                                <div class="col-sm-3">
                                    <mat-form-field appearance="fill">
                                        <mat-label>Enter last four digit</mat-label>
                                        <input matInput type="number" name="lastFourDigit" id="lastFourDigit">
                                    </mat-form-field>
                                </div>

                                <div class="col-sm-1">
                                    <button ng-click="$ctrl.clearCcLastFourDigits()" type="button"
                                        class="btn btn-outline-secondary" style="padding: 4px;">CLR
                                    </button>
                                </div>
                            </div>

                            <div class="row" style="margin-top: 0.5em;">
                                <div class="col-sm-2">
                                    <b>Card Holder</b>
                                </div>

                                <div class="col-sm-10">
                                    <mat-form-field appearance="fill">
                                        <mat-label>select</mat-label>
                                        <mat-select>
                                            <mat-option *ngFor="let cr of card" [value]="cr.value">
                                                {{cr.viewValue}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card" style="margin-top: 0.5em;">
                        <div class="card-header">
                            <h2>Appraisal Address</h2>
                        </div>
                        <div class="card-body">
                            <div class="row" style="margin-top: 1.5em;">
                                <div class="col-sm-1">
                                    <b>
                                        Address
                                    </b>
                                </div>

                                <div class="col-sm-11">
                                    <mat-form-field appearance="fill">
                                        <mat-label>select</mat-label>
                                        <mat-select>
                                            <mat-option *ngFor="let add of address" [value]="add.value">
                                                {{add.viewValue}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="row" style="margin-top: 0.5em;">
                                <div class="col-sm-1">
                                    <b>
                                        City:
                                    </b>
                                </div>

                                <div class="col-sm-3">
                                    <mat-form-field appearance="fill">
                                        <mat-label>select</mat-label>
                                        <mat-select>
                                            <mat-option *ngFor="let city of city" [value]="city.value">
                                                {{city.viewValue}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>

                                <div class="col-sm-1">
                                    <b>
                                        State:
                                    </b>
                                </div>
                                <div class="col-sm-3">
                                    <mat-form-field appearance="fill">
                                        <mat-label>select</mat-label>
                                        <mat-select>
                                            <mat-option *ngFor="let st of state" [value]="st.value">
                                                {{st.viewValue}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>

                                <div class="col-sm-1">
                                    <b>
                                        ZIP:
                                    </b>
                                </div>
                                <div class="col-sm-3">
                                    <mat-form-field appearance="fill">
                                        <mat-label>Enter zip code</mat-label>
                                        <input matInput type="number">
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="row" style="margin-top: 1em;">
                        <div class="col-sm-2">
                            <button ng-click="$ctrl.searchClicked()" type="button" class="btn btn-primary">
                                SEARCH
                            </button>
                        </div>

                        <div class="col-sm-8">
                            &nbsp;
                        </div>

                        <div class="col-sm-2">
                            <button type="reset" class="btn" style="float: right;">
                                CLEAR FILTERS
                            </button>
                        </div>
                    </div>
                </form>
            </div>

        </div>

        <div class="card" style="margin-top: 3em;">
            <div class="example-button-row" style="margin: 0.5em 0.5em;">
                <button mat-stroked-button (click)="exportTable()">Export to Excel</button>
            </div>
        </div>

        <div class="card" style="margin-top: 1em;">
            <table id="ExampleMaterialTable" mat-table [dataSource]="dataSource" class="mat-elevation-z8">
                <ng-container matColumnDef="Tracking">
                    <th mat-header-cell *matHeaderCellDef> Tracking # </th>
                    <td mat-cell *matCellDef="let element"> {{element.Tracking}} </td>
                </ng-container>

                <ng-container matColumnDef="Loan">
                    <th mat-header-cell *matHeaderCellDef> Loan # </th>
                    <td mat-cell *matCellDef="let element"> {{element.Loan}} </td>
                </ng-container>

                <ng-container matColumnDef="SettleDate">
                    <th mat-header-cell *matHeaderCellDef> Settle Date </th>
                    <td mat-cell *matCellDef="let element"> {{element.SettleDate}} </td>
                </ng-container>

                <ng-container matColumnDef="CardHolder">
                    <th mat-header-cell *matHeaderCellDef> Card Holder </th>
                    <td mat-cell *matCellDef="let element"> {{element.CardHolder}} </td>
                </ng-container>


                <ng-container matColumnDef="Card">
                    <th mat-header-cell *matHeaderCellDef> Card </th>
                    <td mat-cell *matCellDef="let element"> {{element.Card}} </td>
                </ng-container>


                <ng-container matColumnDef="SettleAmnt">
                    <th mat-header-cell *matHeaderCellDef> Settle Amount </th>
                    <td mat-cell *matCellDef="let element"> {{element.SettleAmnt}} </td>
                </ng-container>

                <ng-container matColumnDef="BorrowerName">
                    <th mat-header-cell *matHeaderCellDef> BorrowerName</th>
                    <td mat-cell *matCellDef="let element"> {{element.BorrowerName}} </td>
                </ng-container>


                <ng-container matColumnDef="AppraisalAddr">
                    <th mat-header-cell *matHeaderCellDef> AppraisalAddress</th>
                    <td mat-cell *matCellDef="let element"> {{element.AppraisalAddr}} </td>
                </ng-container>


                <ng-container matColumnDef="Response">
                    <th mat-header-cell *matHeaderCellDef> Response</th>
                    <td mat-cell *matCellDef="let element"> {{element.Response}} </td>
                </ng-container>


                <ng-container matColumnDef="Appraiser">
                    <th mat-header-cell *matHeaderCellDef> Appraiser</th>
                    <td mat-cell *matCellDef="let element"> {{element.Appraiser}} </td>
                </ng-container>


                <ng-container matColumnDef="Lender">
                    <th mat-header-cell *matHeaderCellDef>Lender</th>
                    <td mat-cell *matCellDef="let element"> {{element.Lender}} </td>
                </ng-container>

                <ng-container matColumnDef="RefundStatus">
                    <th mat-header-cell *matHeaderCellDef>RefundStatus</th>
                    <td mat-cell *matCellDef="let element"> {{element.RefundStatus}} </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
        </div>
    </div>
</div>